import { MILLISECONDS_IN_SECOND } from '@portal/constants/time-constants';
import { useInterval } from '@portal/shared/hooks';
import { RefObject, useCallback, useState } from 'react';

declare global {
  interface Window {
    Trustpilot: {
      loadFromElement: (element: Element, forceLoad: boolean) => void;
    };
  }
}

export const useForceLoadTrustpilot = (ref: RefObject<HTMLDivElement | null>) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const forceLoadTrustpilot = useCallback(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
      setIsLoaded(true);
    }
  }, [ref]);

  useInterval(forceLoadTrustpilot, isLoaded ? null : MILLISECONDS_IN_SECOND);
};
